import React from 'react'

import type { SvgProps } from './types'

function PerformanceSvg({
  width,
  height,
  className,
  stroke,
  strokeColor,
  fill,
}: SvgProps) {
  return (
    <svg
      width={width || '17'}
      height={height || '17'}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill={fill || 'currentColor'}
      viewBox="0 0 64 70"
      stroke={strokeColor}
      strokeWidth={stroke || 1.5}
    >
      <path d="M32,14.3c-11.9,0-21.7,9.7-21.7,21.7c0,4.9,1.6,9.5,4.6,13.4c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2 c0.4-0.3,0.5-1,0.2-1.4c-2.8-3.5-4.2-7.7-4.2-12.2c0-10.8,8.8-19.7,19.7-19.7s19.7,8.8,19.7,19.7c0,4.5-1.5,8.7-4.2,12.2 c-0.3,0.4-0.3,1.1,0.2,1.4c0.4,0.3,1.1,0.3,1.4-0.2c3-3.8,4.6-8.5,4.6-13.4C53.7,24,43.9,14.3,32,14.3z" />
      <path d="M42.4,24.1l-7.6,7.6C34,31.2,33,30.9,32,30.9c-2.8,0-5.1,2.3-5.1,5.1S29.2,41,32,41s5.1-2.3,5.1-5.1c0-1-0.3-2-0.9-2.8 l7.6-7.6c0.4-0.4,0.4-1,0-1.4S42.8,23.7,42.4,24.1z M32,39c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1S33.7,39,32,39 z" />
      <path d="M41.9,47.7H22.1c-0.6,0-1,0.4-1,1s0.4,1,1,1h19.8c0.6,0,1-0.4,1-1S42.5,47.7,41.9,47.7z" />
    </svg>
  )
}

export default PerformanceSvg
